import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // scroll-behavior: smooth é global (CSS do Bootstrap, usado pelos links
    // âncora dentro da página); sem "instant" aqui, a troca de rota herdava
    // essa animação em vez de abrir direto no topo.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
